import script from "./MediaContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaContent.vue?vue&type=script&lang=ts&setup=true"

import "./MediaContent.vue?vue&type=style&index=0&id=6f25d117&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f25d117"]])

export default __exports__